import EditDetails from "../Components/Account/EditDetails";

function EditUserDetails(){
    return(
        <div>
            <EditDetails></EditDetails>
        </div>
    );
}

export default EditUserDetails;